import { render, staticRenderFns } from "./TblStepsDetail.vue?vue&type=template&id=63a38f4b&scoped=true&"
import script from "./TblStepsDetail.vue?vue&type=script&lang=js&"
export * from "./TblStepsDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblStepsDetail.vue?vue&type=style&index=0&id=63a38f4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a38f4b",
  null
  
)

export default component.exports